import { gql } from "apollo-boost"

export const CREATE_ASSISTANCE = gql`
  mutation CreateAssistance($data: [ActivityAssistanceInput!]!) {
    CreateAssistance(data: $data)
  }
`
